<app-upload-progress-bar [uploadData]="uploadData"></app-upload-progress-bar>
<div class="flex-column flex-md-row flex-wrap justify-center items-center gap-2">
  @if (shouldShowSearchOption()) {
    <button mat-button type="button" (click)="openImageSearch()" [disabled]="disabled">
      <mat-icon>search</mat-icon> {{ 'generic.select' | translate }}
    </button>
  }
  <button mat-button type="button" [disabled]="disabled" (click)="openFile()">
    <mat-icon>note_add</mat-icon>&nbsp;
    {{ 'generic.upload_for_purpose' | translate: {purpose: ('select_media.purpose.' + purpose.replace('-', '_')) | translate} }}
  </button>
  @if ((isAdmin$ | async) && (mediaItemUuid && mediaItemUuid !== '')) {
    <button mat-button type="button" [disabled]="disabled" (click)="replaceImage()">
      <mat-icon>sync</mat-icon>&nbsp;
      {{ 'generic.upload_for_replacement' | translate: {purpose: ('select_media.purpose.' + purpose.replace('-', '_')) | translate | lowercase} }}
    </button>
  }
  @if (removable) {
    <button [disabled]="disabled" mat-button type="button" (click)="remove()">
      <mat-icon>close</mat-icon> {{ 'generic.remove' | translate }}
    </button>
  }
</div>
